import 'jquery-match-height';

let titleEls = $('.catalog-products-item__title');

titleEls.matchHeight();